import { AccountInfo, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { ClinicGlobalStore } from './store/clinic-global.store';
import { Component, HostListener, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../environments/environment';
import { filter, Subject, takeUntil } from 'rxjs';
import { IdleTimeoutService, LoginService } from '@web/csl-lib-services';
import { MessageService } from 'primeng/api';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { RouterModule } from '@angular/router';


@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [MessageService]
})
export class AppComponent implements OnInit, OnDestroy {
  private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private msalService = inject(MsalService);
  private msalBroadcastService = inject(MsalBroadcastService);
  private loginService = inject(LoginService);
  private idleTimeoutService = inject(IdleTimeoutService);

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    /*
     * TODO: add code to handle refresh here
     *  (not sure of exact solution, but early research indicates saving state to
     *  local storage and restoring it on refresh)
     */
  }

  /* Store */
 clinicGlobalStore = inject(ClinicGlobalStore);


  /* Services */


  /* Member Vars */
  title = 'SurvivorLink Clinic Portal';

  private readonly _destroying$ = new Subject<void>();

  ngOnInit(): void {
    // this.msalService.handleRedirectObservable().subscribe();
    // this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.setLoginDisplay();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.LOGOUT_SUCCESS
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    this.idleTimeoutService.startIdleDetection(environment.production ? 30 : 10);

    // Subscribe to the LOGIN_SUCCESS event; when the user has logged in, get the clinic
    // from the claims and set it in the store. This will trigger other initialization events.
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        const account = result.payload as AccountInfo;

        if (
          account.idTokenClaims &&
          account.idTokenClaims['extension_ClinicStaffProfile']
        ) {

          const clinicStaffProfile = JSON.parse(account.idTokenClaims['extension_ClinicStaffProfile'].toString());
          this.clinicGlobalStore.initClinic(clinicStaffProfile.clinicId);

        } else {
          this.msalService.logoutRedirect({
            account,
            idTokenHint: account.idToken,
            postLogoutRedirectUri: environment.logoutRedirectUrl,
          });
        }

      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  /* Event Handlers */




  /* Instance Methods */

 setLoginDisplay() {
    // Use a signal so other components and inject loginService can subscribe to loginDisplay changes
    this.loginService.loginDisplaySig.set(this.msalService.instance.getAllAccounts().length > 0);
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.msalService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }


}


